import { getFoods } from '../state-manager.js';
import { fetchFeeds, deleteFeed } from '../requests/profiles.js';
import { hydrateSummary } from './ui-summary.js';
import { createFeedRow } from './feed-row-utils.js';
import { showShimmer, hideShimmer } from './ui-shimmer.js';
import { isToday } from './date-utils.js';

export async function hydrateFeeds(profileId, addedRecordId = null) {
  const panel = document.getElementById('app-feeds-panel');
  const container = panel?.querySelector('.table-rows');
  panel?.classList.remove('hidden');
  
  console.log('[UI-Feeds] Hydrating feeds for profile:', profileId);

  showShimmer(container, 'Loading feeding history...');

  const records = await fetchFeeds(profileId);
    
  const foods = getFoods();
  if (!foods || foods.length === 0) {
    console.warn('[UI-Feeds] No foods found in the state.');
    // hideShimmer(container);
    return;
  }

  container.innerHTML = '';

  let totalIntake = 0;
  let totalIntakeYesterday = 0;
  
  if (records.length === 0) {
    showShimmer(container, 'No records yet');
  } else {
    hideShimmer(container); // Just in case
  }

  for (const feed of records.sort((a, b) => new Date(a.created_at) - new Date(b.created_at))) {
    const food = foods.find(f => f.id === feed.food_id && f.profile_ids.includes(profileId));
    if (!food) continue;

    const { element: row, intake } = createFeedRow(feed, food, {
      profileId,
      isHighlighted: feed.id === addedRecordId,
      onUndo: () => deleteFeed(profileId, feed.id)
    });

    // Check if the feed date is today
    const feedDate = new Date(feed.created_at + 'Z'); // Ensure UTC parsing
    if (isToday(feedDate)) {
      totalIntake += intake;
    }
    else {
      totalIntakeYesterday += intake;
    }
    container.appendChild(row);

    row.classList.add('feed-row'); // base style with opacity 0

    // Append the row first
    container.appendChild(row);
    
    // Then trigger appearance animation
    requestAnimationFrame(() => {
      row.classList.add('feed-appear'); // triggers the transition
    });        
  }
  hydrateSummary(profileId, totalIntake, totalIntakeYesterday);

  // Scroll to bottom
  //Autoscroll
  const lastRow = document.querySelector(".table-rows tr:last-child"); // Select the last row
  if (lastRow) {
    panel.scrollTop = panel.scrollHeight; // Move to bottom smoothly
  }     
}